import { Dialog, DialogContent, DialogProps, ImageList, ImageListItem } from '@mui/material';
import { FC } from 'react';
import { InformationDialogTitle } from '../../../../lib/components/compound/dialogs/informationDialog/title';

type Props = {
  title?: string;
  icon?: JSX.Element;
  onClose: () => void;
  onConfirm?: () => void;
  onImageSelect?: (imageName: string) => void;
  confirmButtonText?: string;
  cancelButtonText?: string;
} & Pick<DialogProps, 'open'>;

export const GalleryDialog: FC<Props> = ({
  open,
  onClose,
  onConfirm,
  onImageSelect,
  title,
  icon
}) => {
  const handleSelection = (imageUrl: string) => {
    onConfirm?.();
    onImageSelect?.(imageUrl.split('/').pop() || '');
    onClose();
  };

  const imageUrls = [
    'https://files.pxtra.de/benefit-images/header_002.jpeg',
    'https://files.pxtra.de/benefit-images/header_003.jpeg',
    'https://files.pxtra.de/benefit-images/header_004.jpeg',
    'https://files.pxtra.de/benefit-images/header_001.jpeg',
    'https://files.pxtra.de/benefit-images/header_005.jpeg',
    'https://files.pxtra.de/benefit-images/header_006.jpeg',
    'https://files.pxtra.de/benefit-images/header_007.jpeg',
    'https://files.pxtra.de/benefit-images/header_008.jpeg',
    'https://files.pxtra.de/benefit-images/header_009.jpeg',
    'https://files.pxtra.de/benefit-images/header_010.jpeg',
    'https://files.pxtra.de/benefit-images/header_011.jpeg',
    'https://files.pxtra.de/benefit-images/header_012.jpeg',
    'https://files.pxtra.de/benefit-images/header_013.jpeg',
    'https://files.pxtra.de/benefit-images/header_014.jpeg',
    'https://files.pxtra.de/benefit-images/header_015.jpeg',
    'https://files.pxtra.de/benefit-images/header_016.jpeg',
    'https://files.pxtra.de/benefit-images/header_017.jpeg',
    'https://files.pxtra.de/benefit-images/header_018.jpeg',
    'https://files.pxtra.de/benefit-images/header_019.jpeg'
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={'md'}
      PaperProps={{
        className: 'flex flex-col justify-center max-h-[52vh] shadow-900'
      }}
    >
      {title && <InformationDialogTitle title={title} onClose={onClose} icon={icon} />}
      <DialogContent
        dividers
        sx={{
          borderBottom: 'none',
          paddingTop: '8px',
          paddingBottom: '8px',
          overflow: 'hidden'
        }}
      >
        <ImageList sx={{ width: 750, height: 378 }} cols={2} rowHeight={250} gap={15}>
          {imageUrls.map((imageUrl, index) => (
            <ImageListItem key={imageUrl}>
              <img
                src={imageUrl}
                alt={`Image ${index}`}
                loading="lazy"
                onClick={() => handleSelection(imageUrl)}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </DialogContent>
    </Dialog>
  );
};
